// @flow
import type { Sample, DataField, TestSchedule, Product, DataFieldName } from "../../lib/Types";
import React, { Fragment } from "react";
import ShoppingCart from "./ShoppingCart";
import BasketData from "../../lib/BasketData";
import SampleForm from "./SampleForm";
import SampleStore from "../../lib/SampleStore";
import { Table, Thead, TableContainer, HeaderText, SubTitle } from "./styles/Theme";
import Expander from "../Expander";
import Link from "../Link";

type Props = {
  samples: Array<Sample>,
  groupName: string,
  store: SampleStore,
  focusedSample: Sample,
  focusSample: Function,
  openedSample: ?Sample,
  openSample: Function,
  openNextSample: Function,
  openPreviousSample: Function,
  companyId: number,
};

export default class SampleGroup extends React.Component<Props> {
  state = {
    expanded: true,
  };

  hasTurnaroundPremiums = () => {
    const { samples } = this.props;
    var has = false;
    samples.map((s) => {
      if (
        s.turnaround_premium_set &&
        s.turnaround_premium_set.turnaround_premiums.length > 0
      ) {
        has = true;
        return;
      }
    });
    return has;
  };

  hasRegisterFromQuote = () => {
    const { samples } = this.props;
    var has = false;
    samples.map((s) => {
      if (!s.schedule.client_suite_id && s.schedule.matrix_id) {
        has = true;
        return;
      }
    });
    return has;
  };

  hasClientSuite = () => {
    const { samples } = this.props;
    var has = false;
    samples.map((s) => {
      if (s.schedule.client_suite_id) {
        has = true;
        return;
      }
    });
    return has;
  };

  uniqueDataFieldNames = (): Array<DataFieldName> => {
    const { samples } = this.props;
    const result = [];
    samples.forEach((sample) => {
      sample.data_fields.forEach((data_field) => {
        if (!result.find((dfn) => dfn.id === data_field.data_field_name.id)) {
          result.push(data_field.data_field_name);
        }
      });
    });
    return result;
  };

  renderTabularForms() {
    const {
      store,
      samples,
      groupName,
      focusedSample,
      focusSample,
      openedSample,
      openSample,
      openNextSample,
      openPreviousSample,
      companyId,
    } = this.props;
    const { expanded } = this.state;
    const uniqueDataFieldNames = this.uniqueDataFieldNames();
    const hasTurnarounds = this.hasTurnaroundPremiums();
    const showMatrix = this.hasRegisterFromQuote();
    const showClientSuite = this.hasClientSuite();
    return (
      <TableContainer>
        <HeaderText>
          <Link onClick={() => this.setState({ expanded: !expanded })}>
            <Expander expanded={expanded} />
            {groupName}
            <SubTitle>{samples.length} samples</SubTitle>
          </Link>
        </HeaderText>
        {expanded && (
          <Table>
            <Thead>
              <tr>
                <th style={{ width: 30 }}>&nbsp;</th>
                <th>{I18n.t("sample_testing")}</th>
                <th>{I18n.t("product")}</th>
                {showMatrix && <th>{I18n.t("matrix")}</th>}
                {showClientSuite && <th>{I18n.t("suite")}</th>}
                <th>{I18n.t("requested_test_date")}</th>
                {hasTurnarounds && <th>{I18n.t("turnaround")}</th>}
                {uniqueDataFieldNames.map((dfn) => (
                  <th key={dfn.id}>{dfn.name}</th>
                ))}
              </tr>
            </Thead>
            <tbody>
              {samples.map((sample, i) => (
                <SampleForm
                  key={i}
                  sample={sample}
                  showTurnarounds={hasTurnarounds}
                  showMatrix={showMatrix}
                  showClientSuite={showClientSuite}
                  dataFieldNames={uniqueDataFieldNames}
                  store={store}
                  selected={focusedSample === sample}
                  opened={openedSample === sample}
                  focusSample={focusSample}
                  openSample={openSample}
                  openNextSample={openNextSample}
                  openPreviousSample={openPreviousSample}
                  mode="tabular"
                  companyId={companyId}
                />
              ))}
            </tbody>
          </Table>
        )}
      </TableContainer>
    );
  }

  // renderSingleColumnForms() {
  //   const { store, samples } = this.props;
  //   return samples.map((sample, i) => (
  //     <SampleForm mode="single_column" key={i} sample={sample} store={store} />
  //   ));
  // }

  render() {
    if (this.props.samples.length === 0) return null;
    return <Fragment>{this.renderTabularForms()}</Fragment>;
  }
}
